import React, { FC } from 'react'
import { Card, StoreCard } from 'components/Card'
import { StoreType } from 'types/store'

type Props = {
  stores: StoreType[]
}

const StoreCardList: FC<Props> = (props) => {
  const { stores } = props
  return (
    <Card>
      {stores.map((store) => {
        if (!store.store_id || !store.shop_ref) return
        return (
          <StoreCard
            key={store.store_id}
            hasScheduleTypes={store.has_schedule_types}
            hasStockTypes={store.has_stock_types}
            imageUrl={store.image_urls?.[0] ?? ''}
            name={store.name}
            shopId={store.shop_ref.id}
            state={store.address?.state ?? ''}
            status={store.status}
            storeId={store.store_id}
          />
        )
      })}
    </Card>
  )
}

export default StoreCardList
